<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-money-check-alt fa-fw" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="title">{{plan.user.first_name}} {{plan.user.last_name}}</div>
            <div class="meta">{{plan.monthly | currency}}/mo for {{plan.term}} months</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat"><i class="fal fa-barcode-alt"></i>{{plan.id}}</span>
            </div>
        </template>
        <template v-slot:details>
            <div class="details">
                <div class="mb-3">
                    <div class="mb-1"><strong>{{plan.paid | currency}}</strong> paid of <strong>{{plan.total | currency}}</strong></div>
                    <b-progress height="4px" :value="(plan.paid/plan.total)*100"></b-progress>
                </div>

                <toolbar class="toolbar">
                    <button class="icon-only" v-b-tooltip.hover title="Make a Payment" @click.stop=""><i class="far fa-credit-card"></i></button>
                    <button class="icon-only" v-b-tooltip.hover title="View Contract" @click.stop=""><i class="far fa-pen-nib"></i></button>
                    <button class="icon-only" v-b-tooltip.hover title="Edit Plan" @click.stop=""><i class="far fa-pencil"></i></button>
                    <button class="icon-only" v-b-tooltip.hover title="User Details" @click.stop=""><i class="far fa-user"></i></button>
                </toolbar>

                <div class="data mt-1">
                    <data-row mini title="Term">12 Months</data-row>
                    <data-row mini title="Created"></data-row>
                    <data-row mini title="Plan ID">{{plan.id}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "./common/Toolbar";
    import DataRow from "./common/DataRow";
    import CardListItem from "./common/CardListItem";

    export default {
        name: 'PaymentPlanListItem',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            plan: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                details: false,
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/variables';

    li {
        .status-icons {
            margin-top: 0.3rem;
            font-size: 0.7rem;
            i {
                font-size: 0.65rem;
            }
        }

        .details {
            margin: 0.7rem 0 0.3rem;
        }
    }
</style>
